<sd-scandata-tree
  [scandata]="scandata"
  (modelIconClick)="modelIconClick($event)"
  (modelNameClick)="modelIconClick($event)"
  (modelPlayClick)="modelPlayClick($event)"
></sd-scandata-tree>
